var _style, _path, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashIconAlertRedBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.2,98.4C23.5,98.4,1.8,76.7,1.8,50S23.5,1.5,50.2,1.5S98.7,23.3,98.7,50S76.9,98.4,50.2,98.4z M50.2,9.7 C28,9.7,10,27.8,10,50c0,22.2,18,40.2,40.2,40.2s40.2-18,40.2-40.2C90.5,27.8,72.4,9.7,50.2,9.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.9,
    y: 23.2,
    className: "st0",
    width: 10.6,
    height: 37.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50.2,
    cy: 73.2,
    r: 6.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIconAlertRedBanner);
export default __webpack_public_path__ + "static/media/dash_icon_alert_red_banner.e201c3a20fcfef13dc6e23767282262a.svg";
export { ForwardRef as ReactComponent };